import './index.scss';

export const SectionDescription = ({ children, ...otherProps }) => (
	<p className="section-description" {...otherProps}>
		{children}
	</p>
);
